<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="10" class="box">
            <div class="box2">
              <el-button type="primary" @click="search(-11)" v-if="navi.prev">
                《《
              </el-button>
              <el-date-picker
                v-model="mth"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>
              <el-button type="primary" @click="search(11)" v-if="navi.next"
                >》》</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button
        type="success"
        size="mini"
        v-has-permission-code-and="'003500350010'"
        @click="batchPay()"
        icon="el-icon-plus"
        >批量发放</el-button
      >
      {{ msg }}
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="name" width="110" label="月份"></el-table-column>
        <el-table-column prop="dpt" width="85" label="部门"></el-table-column>
        <el-table-column
          prop="bxemp"
          width="90"
          label="申请人"
        ></el-table-column>
        <el-table-column
          prop="cost"
          width="220"
          label="报销合计金额(元)"
        ></el-table-column>
        <el-table-column
          prop="cnt"
          width="100"
          label="含报销项数"
        ></el-table-column>
        <el-table-column prop="paytm" label="发放时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="220px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button
                type="success"
                size="mini"
                v-if="!scope.row.paytm"
                v-has-permission-code-and="'003500350010'"
                @click="batchPay(scope.row)"
                >发放</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <el-dialog
      title="请选择发放账户"
      :visible.sync="dialogTableVisible"
      width="25%"
      :before-close="handleClose"
      :modal="false"
    >
      <br />
              <el-date-picker
                v-model="paytm"
                type="date"
                placeholder="选择发放时间"
                value-format="yyyy-MM-dd"
              ></el-date-picker><br>
               <el-select v-model="cpttpname" placeholder="请选择发放账户:">
              <el-option
                 v-for="item in cwcnts"
                 :key="item.cpttpname"
                 :label="item.cpttpname"
                 :value="item.cpttpname"
               >
              </el-option>
            </el-select>
       <br>
      <span>{{msg2}}</span>
      <span slot="footer" class="dialog-footer">
           <el-button @click="pay">确认</el-button>
        <el-button @click="dialogTableVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/cw/riems.js";
import apiCwcnt from "@/api/cw/cwacount.js";

export default {
  name: "riems",
  components: {},
  data() {
    return {
      searchParams: {},
      listLoading: false,
      dialogTableVisible:false,
      listData: [],
      selected: [],
      cwcnts:[],
      mth: "",
      paytm:"",
      cpttpname:"",
      sumPay: 0,
      sumVal: 0,
      msg: "",
      msg2: "",
      navi: {},
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;

      if (this.month && Date == typeof this.month) {
        this.searchParams.month = this.month.format("yyyy-MM");
      }

      api.listmth(this.searchParams, (response) => {
        this.listData = response.data.pages;
        this.navi = response.data.navi;
        this.mth = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
        this.listLoading = false;
      });
    },handleClose(){
      this.msg2=""
    },
    pay(){

        if (!this.paytm ||!this.cpttpname  ) {
          this.$utils.msg.info("请选择");
          return;
        }

        let param = {
              mth: this.mth.format("yyyy-MM"),
              paytm:this.paytm,
              cpttpname:this.cpttpname,
              nms:this.selected
        };
        console.log(param)
         api.pay(
             param,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
             this.dialogTableVisible = false
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
            }
        );
   
    },
    //批量支付
    batchPay(row) {
      if (row) {
        //支付一个人
        if (row.paytm) {
            this.$utils.msg.info("已经发放无需重复发放!");
        } else {
           this.dialogTableVisible = true
           this.msg2 = "确定发放"+row.bxemp+"的报销合计"+row.cost+"元吗?" 
           this.selected = [row.bxemp]

        }
      } else {

        if (!this.selected || this.selected.length == 0) {
          this.$utils.msg.info("请选择至少一行");
          return;
        }
        if ( this.sumPay>0) {
          this.$utils.msg.info("选中的人中含有已经发放的报销!");
          return;
        }
         this.dialogTableVisible = true
          this.msg2="确定批量发放"+this.selected.length+"人合计报销金额:"+this.sumVal+"元?"
      }
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      this.sumVal = 0;
      this.sumPay = 0;

      for (let item of val) {
        this.selected.push(item.bxemp);
        this.sumVal += item.cost * 1;
        if (item.paytm) {
          this.sumPay += item.cost * 1;
        }
      }

      if (this.selected.length > 0) {
        this.msg =
          "  已选择: " +
          this.selected.length +
          " 人,报销合计: " +
           this.sumVal.toFixed(2) +
          " 元,其中已发放:" +
          this.sumPay +
          "元";
      } else {
        this.msg = "";
        this.sumPay = 0;
        this.sumVal = 0;
        this.selected=[]
      }
    },
    search(type) {
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.mth = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.mth = this.navi.next;
        } else if (type == 1) {
          // 时间选择器
          this.searchParams.mth = this.mth;
        }
      }
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.mth = "";
      this.msg = "";
      this.sumVal = 0;
      this.sumPay = 0;
      this.list();
    },
  },
  mounted() {
      this.list();

  let me = this.$caches.user.get();

    if ( me.role2 == "admin" ||  me.role2 == "mgr") {
        apiCwcnt.list({}, (res2) => {
            this.cwcnts = res2.data;
         });
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.operator {
  margin-top: 4px;
}
.errorClass {
  margin-top: 4px;
}
</style>

